export { default as assignProps } from './assignProps.js';
export { default as bemComponent } from './bemComponent.jsx';
export { default as functionOrFalse } from './functionOrFalse.js';
export { default as getComponentClasses } from './getComponentClasses.js';
export { default as propertyOrNull } from './propertyOrNull.js';




// WEBPACK FOOTER //
// ./~/@99designs/utils/app/index.js